import React from 'react';
import { Name } from './Name';
import { Value } from './Value';
export function Leaf(_ref) {
  let {
    data: [key, value]
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement(Name, {
    data: key,
    style: {
      flex: 'none'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 'none'
    }
  }, ":\xA0"), /*#__PURE__*/React.createElement(Value, {
    data: value
  }));
}